import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderBy'
})

// order may be 'asc' -> ascending and 'desc' -> descending

export class OrderByPipe implements PipeTransform {
    transform(array: any, field: string, order: string): any[] {
        if (!Array.isArray(array)) {
            return;
        }
        let multiplier = 1;
        if (order === 'desc') {
            multiplier = -1;
        }
        array.sort((a: any, b: any) => {
            if (a[field] < b[field]) {
                return -multiplier;
            } else if (a[field] > b[field]) {
                return multiplier;
            } else {
                return 0;
            }
        });
        return array;
    }
}
